import type { Next } from '@wix/funnel-builder-lizard'

import type { PageLogger } from '../../../../../bi/mfi'
import { onboardingAnswer } from '../../../../../bi/onboarding'
import { createMetadataFromBusinessTerm } from '../../../../../category/categoryInMetadata'
import { Save } from '../../../../../context/StorageContext/StorageContext'
import { getSuggestList } from '../getSuggestList'
import type { StateCategory } from '../types'

type GoNextParams = {
  category?: StateCategory
  pageLogger: PageLogger
  language: string
  questionKey: string
  next: Next
  save: Save
}

export const goNext = (params: GoNextParams) => {
  const { save, category, pageLogger, language, questionKey, next } = params

  // do next only if there is a category (even the fallback one without business term)
  if (!category) {
    return
  }
  const { businessTerm = {}, businessSegmentId, search, searchSource, index } = category
  const { displayName } = businessTerm

  const metadata = createMetadataFromBusinessTerm(businessTerm, businessSegmentId)
  const { segment, industryId, structureId } = metadata

  void pageLogger.answerCategory({
    businessTerm,
    segment,
    businessSegmentId,
    userSearchInput: businessTerm.displayNameOverride,
  })
  void pageLogger.answer({ answer: businessTerm || '{}', position: index + 1 })
  void onboardingAnswer({
    contentLanguage: language,
    navButton: 'next',
    text: search,
    suggestList: getSuggestList(searchSource),
    name: displayName || '',
    selectedIndustryId: industryId || '',
    selectedStructureId: structureId || '',
  })

  const answerValues = displayName ? [displayName] : []
  const answers = { [questionKey]: { values: answerValues } }

  save({ category })
  next(answers, metadata)
}
